import React, { useEffect, useState } from 'react';
import { createStyles, IconButton, makeStyles, Theme } from '@material-ui/core';
import { Close } from '@material-ui/icons';

type Tprops = {
  base64String: string;
  index: number;
  setValue?: any;
  deletePicture?: (index: number) => void;
  listName: string;
  isDeletable?: boolean;
};

export const DailyReportImageBase64ListItem: React.FC<Tprops> = (
  props: Tprops
) => {
  const {
    base64String,
    index,
    setValue,
    deletePicture,
    listName,
    isDeletable = false
  } = props;

  const classes = useStyles();

  const [image, setImage] = useState<any>(null);

  useEffect(() => {
    const imageUrl = `data:image/jpeg;base64,${base64String}`;
    setImage(imageUrl);
  }, [base64String]);

  return (
    <div className={classes.imgWrapper}>
      <img className={classes.img} src={image} alt='company-seal' />
      {isDeletable && (
        <IconButton
          aria-label='close'
          className={classes.closeIcon}
          onClick={() => {
            if (deletePicture) deletePicture(index);
          }}
          size='small'
        >
          <Close />
        </IconButton>
      )}
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      //モーダルを中央に
      display: 'flex',
      alignItems: 'center'
    },
    imgWrapper: {
      marginBottom: 5,
      marginRight: 5,
      position: 'relative'
    },
    img: {
      objectFit: 'cover',
      border: 'solid 1px rgba(0,0,0,0.23)',
      '@media screen and (min-width:600px)': {
        height: '77px',
        width: '77px'
      },
      '@media screen and (max-width:600px)': {
        height: '107px',
        width: '107px'
      }
    },
    closeIcon: {
      position: 'absolute',
      right: 0,
      top: 0,
      color: theme.palette.grey[500],
      width: 10,
      height: 10
    }
  })
);
